import { PENDING_DOWNLOADS_KEY } from "../eventConstants";
import LocalStorage from "../LocalStorage";

export interface PendingPromotionCompilationJob {
  createdAt: number;
  promotionId: string;
  accountId: string;
  jobId: string;
}

const updatePendingPromotionList = (
  accountId: string,
  newPendingPromotions: PendingPromotionCompilationJob[]
): PendingPromotionCompilationJob[] => {
  LocalStorage.setJSONValue(PENDING_DOWNLOADS_KEY, {
    ...LocalStorage.getJSONValue(PENDING_DOWNLOADS_KEY),
    [accountId]: newPendingPromotions,
  });
  return [...newPendingPromotions];
};

export const getPendingDownloadJobs = (
  accountId: string
): PendingPromotionCompilationJob[] =>
  (LocalStorage.getJSONValue(PENDING_DOWNLOADS_KEY)[
    accountId
  ] as PendingPromotionCompilationJob[]) || [];

export const removeExpiredPromotionCompilationJobs = (
  accountId: string,
  remainingJobs: PendingPromotionCompilationJob[],
  timeout: number
): {
  validJobs: PendingPromotionCompilationJob[];
  expiredJobs: PendingPromotionCompilationJob[];
} => {
  const { validJobs, expiredJobs } = remainingJobs.reduce(
    (acc, job) => {
      if (Date.now() - job.createdAt >= timeout) {
        return { ...acc, expiredJobs: [...acc.expiredJobs, job] };
      }
      return { ...acc, validJobs: [...acc.validJobs, job] };
    },
    {
      validJobs: [] as PendingPromotionCompilationJob[],
      expiredJobs: [] as PendingPromotionCompilationJob[],
    }
  );

  updatePendingPromotionList(accountId, validJobs);
  return { validJobs, expiredJobs };
};

export const addPendingPromotionDownloadJobs = (
  accountId: string,
  newJobs: PendingPromotionCompilationJob[]
): PendingPromotionCompilationJob[] => {
  const updatedJobs = [...getPendingDownloadJobs(accountId), ...newJobs];
  return updatePendingPromotionList(accountId, updatedJobs);
};

export const removeCompletedPromotionCompilationJobs = (
  accountId: string,
  completedJobIds: string[]
): PendingPromotionCompilationJob[] => {
  const storedPendingDownloads = getPendingDownloadJobs(accountId);
  if (completedJobIds.length === 0) {
    return storedPendingDownloads;
  }
  const updatedPendingDownloads = storedPendingDownloads.filter(
    (job) => !completedJobIds.includes(job.jobId)
  );
  return updatePendingPromotionList(accountId, updatedPendingDownloads);
};

export const saveDisplayMyPromoLink = (displayPromotions: boolean) =>
  LocalStorage.setJSONValue("displayPromotions", {
    displayPromotions,
  });

const getStoredDisplayPromotions = (): boolean => {
  const displayPromotions =
    LocalStorage.getJSONValue("displayPromotions")?.displayPromotions;
  return displayPromotions === undefined || displayPromotions === null
    ? true
    : displayPromotions !== false;
};

const getDisplayPromotionsFromUrl = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const displayPromotions = urlParams.get("displayMyPromoLink");
  return displayPromotions;
};

export const getDisplayPromotions = (): boolean => {
  const displayPromotions = getDisplayPromotionsFromUrl();
  if (displayPromotions !== undefined && displayPromotions !== null) {
    saveDisplayMyPromoLink(displayPromotions !== "false");
    return displayPromotions !== "false";
  }
  return getStoredDisplayPromotions();
};
